import { handledErrors } from './handled-errors';
import { BASE_REST_URL } from '../../constants/endpoints';

export const isUnhandledError = (status: number, request: XMLHttpRequest): boolean => {
  const baseUrl = BASE_REST_URL || '';
  const requestUrl = request.responseURL.replace(`${baseUrl}/`, '');

  const handled = handledErrors[requestUrl];

  return !(handled?.includes(status));
};
